import React, { Component } from 'react'
import Ink from 'react-ink'
import { connect } from 'react-redux'
import { setCustomerExistsModal } from '../actions/generalActions'
import PropTypes from 'prop-types'

class CustomerExistsListItem extends Component {
    constructor(props) {
        super(props);
        this.handleTouchTap = this.handleTouchTap.bind(this);
    }

    handleTouchTap() {
        this.props.Callback(this.props.Customer);
    }

    render() {
        const customer = this.props.Customer;
        const name = customer.Name == null ? "" : customer.Name;
        const street = customer.Street == null ? "" : customer.Street;
        const houseNumber = customer.HouseNumber == null ? "" : customer.HouseNumber;
        const zipCode = customer.ZipCode == null ? "" : customer.ZipCode;
        const city = customer.City == null ? "" : customer.City;
        const email = customer.Email == null ? "" : customer.Email;
        const telephoneNumber1 = customer.TelephoneNumber1 == null ? "" : customer.TelephoneNumber1;
        return (
            <div className="listdiv">
                <button className="customerListItem" onClick={evt => this.handleTouchTap(false)}>
                    <label className="listItemLabelTop">{name}</label>
                    <label className="listItemLabel">{(street + " " + houseNumber).trim()}</label>
                    <label className="listItemLabel">{(zipCode + " " + city).trim()}</label>
                    <label className="listItemLabel">{email}</label>
                    <label className="listItemLabel">{telephoneNumber1}</label>
                    <Ink />
                </button>
            </div>
        )
    }
}

CustomerExistsListItem.propTypes = {
    Customer: PropTypes.object.isRequired,
    Callback: PropTypes.func
}
function mapStateToProps() {
    return {

    }
}

export default connect(mapStateToProps, { setCustomerExistsModal })(CustomerExistsListItem)


// WEBPACK FOOTER //
// src/components/CustomerExistsListItem.jsx